import React from 'react'
import Newsletter from '../components/Newsletter'
import BenefitCard from '../components/BenefitCard'
import Faq from '../components/Faq'
import { FaBell, FaChartLine, FaFileAlt, FaShieldAlt } from 'react-icons/fa'

const NewsletterPage = () => {
  const benefits = [
    {
      icon: <FaBell className='w-12 h-12 text-primary' />,
      title: 'Actualizaciones Inmediatas',
      description:
        'Recibe notificaciones instantáneas sobre cambios en la normativa fiscal y nuevas clasificaciones de actividades económicas que puedan afectar a tu negocio.',
    },
    {
      icon: <FaChartLine className='w-12 h-12 text-primary' />,
      title: 'Optimización Fiscal',
      description:
        'Descubre oportunidades para optimizar la clasificación de tu actividad empresarial y potencialmente reducir tu carga fiscal.',
    },
    {
      icon: <FaFileAlt className='w-12 h-12 text-primary' />,
      title: 'Guías Especializadas',
      description:
        'Accede a guías detalladas sobre cómo interpretar y aplicar correctamente los códigos IAE y CNAE en tus trámites administrativos.',
    },
    {
      icon: <FaShieldAlt className='w-12 h-12 text-primary' />,
      title: 'Cumplimiento Normativo',
      description:
        'Mantén tu negocio en cumplimiento con la legislación vigente y evita posibles sanciones por clasificaciones incorrectas.',
    },
  ]

  return (
    <div className='container mx-auto px-4 py-12'>
      <div className='text-center mb-12'>
        <h1 className='text-3xl md:text-4xl font-bold text-text-primary mb-4'>
          Boletín Especializado en Epígrafes IAE y Códigos CNAE
        </h1>
        <p className='text-text-secondary max-w-3xl mx-auto'>
          Mantente informado sobre todos los cambios y actualizaciones
          relevantes para tu actividad empresarial. Nuestro boletín te
          proporciona información valiosa directamente en tu bandeja de entrada.
        </p>
      </div>

      <div className='mb-16'>
        <h2 className='text-2xl font-bold text-text-primary mb-8 text-center'>
          ¿Por qué suscribirte a nuestro boletín?
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className='bg-surface bg-opacity-30 rounded-lg p-6'
            >
              <div className='flex items-start mb-4'>
                <div className='mr-4 flex-shrink-0'>{benefit.icon}</div>
                <div>
                  <h3 className='text-lg font-bold text-text-primary mb-2'>
                    {benefit.title}
                  </h3>
                  <p className='text-text-secondary'>{benefit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='mb-16'>
        <h2 className='text-2xl font-bold text-text-primary mb-8 text-center'>
          Lo que nuestros suscriptores dicen
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          <div className='bg-surface bg-opacity-30 rounded-lg p-6'>
            <p className='text-text-secondary italic mb-4'>
              "Gracias a las actualizaciones del boletín, pude reclasificar mi
              actividad empresarial justo a tiempo para el cambio normativo. Me
              ahorró tiempo y dinero en gestiones."
            </p>
            <p className='text-text-primary font-semibold'>
              - María G., Autónoma
            </p>
          </div>
          <div className='bg-surface bg-opacity-30 rounded-lg p-6'>
            <p className='text-text-secondary italic mb-4'>
              "Las guías especializadas me han ayudado enormemente a entender
              mejor cómo aplicar correctamente los códigos CNAE en mi empresa.
              Un recurso invaluable."
            </p>
            <p className='text-text-primary font-semibold'>- Carlos R., Pyme</p>
          </div>
        </div>
      </div>

      <Newsletter />

      <Faq
        title='Preguntas Frecuentes sobre la Newsletter'
        description='Resolvemos tus dudas sobre nuestro boletín especializado en epígrafes IAE y códigos CNAE'
        faqData={[
          {
            question: '¿Con qué frecuencia recibiré el boletín?',
            answer:
              'Enviamos actualizaciones mensuales regulares, con boletines especiales adicionales cuando hay cambios importantes en la normativa o nuevas funcionalidades en nuestra plataforma.',
          },
          {
            question: '¿Puedo cancelar mi suscripción en cualquier momento?',
            answer:
              'Sí, cada boletín incluye un enlace para darte de baja fácilmente si así lo deseas. Tu privacidad y preferencias son importantes para nosotros.',
          },
          {
            question: '¿El contenido está adaptado a mi sector específico?',
            answer:
              'Nuestro boletín cubre una amplia gama de sectores y actividades económicas, proporcionando información relevante para diversos tipos de negocios y profesionales.',
          },
          {
            question: '¿Qué tipo de información incluye el boletín?',
            answer: {
              intro:
                'Nuestro boletín incluye información valiosa y actualizada sobre:',
              bullets: [
                'Actualizaciones oficiales de epígrafes IAE y códigos CNAE',
                'Cambios normativos que afectan a tus obligaciones fiscales',
                'Guías prácticas para la correcta clasificación de tu actividad',
                'Consejos para optimizar tu situación fiscal',
                'Novedades y mejoras en nuestra plataforma',
              ],
            },
          },
          {
            question: '¿Cómo puedo acceder a boletines anteriores?',
            answer:
              'Todos nuestros suscriptores tienen acceso a un archivo histórico de boletines anteriores a través de un enlace exclusivo que se incluye en cada nueva edición.',
          },
          {
            question: '¿La suscripción tiene algún costo?',
            answer:
              'No, nuestro boletín es completamente gratuito. Nuestro objetivo es proporcionar información valiosa y actualizada a todos los profesionales y empresas interesados en mantenerse al día con los cambios en epígrafes IAE y códigos CNAE.',
          },
        ]}
      />
    </div>
  )
}

export default NewsletterPage
